import React, { Component } from 'react'
import GradesPV from './GradesPV'
import AuthA from '../../store/actions/AuthA'
import QuarterA from '../../store/actions/QuarterA'
import Papa from 'papaparse'

import axios from 'axios'
import sortBy from 'lodash/sortBy'
import find from 'lodash/find'
import constantCase from 'constant-case'
import paramCase from 'param-case'
import {connect} from 'react-redux'
import { getQuarterDbField, isValidQuarter } from '../../utils/quarterUtils'
import { resolveGradingScheme } from '../../utils/gradingScheme'
import { countSlots, countFilled, ratingKey } from '../Pace/paceGrid'

const _ = {
    sortBy: sortBy,
    find: find
}

const changeCase = {
  constantCase: constantCase,
  paramCase: paramCase
}

class GradesPC extends Component {
  constructor(props) {
    super(props);
    this.state = {
      grades: [],
      section: [],
      sectionSubject: [],
      sectionSubjectId: '',
      column: null,
      direction: null,
      sectionStudents: [],
      error: false,
      success: false,
      fileName: '',
      gradeSheet: null,
      areGradesSaved: false,
      results: [],
      dirtyInput: false,
      open: false,
      created: [],
      checked: [],
      reviewed: [],
      subjects: []
    };
    this.getGrades = this.getGrades.bind(this);
    this.getSection = this.getSection.bind(this);
    this.getSectionStudents = this.getSectionStudents.bind(this);
    this.handleUpdateSectionSubjectDetails = this.handleUpdateSectionSubjectDetails.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.handleUploadFileChange = this.handleUploadFileChange.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleDataChange = this.handleDataChange.bind(this);
    this.handleDataSave = this.handleDataSave.bind(this);
  }

  getGrades(sectionSubjectId) {
    const { sectionStudents } = this.state;
    const { currentQuarter } = this.props;
    axios.get(process.env.REACT_APP_URL+'/grades?filter[where][active]=true&filter[where][sectionSubjectId]='+sectionSubjectId)
    .then(response => {
      this.setState({ grades: response.data}, () => {
        if (response.data.length !== 0) {
          sectionStudents.map((sectionStudent, key )=> {
            const studentName = sectionStudent.student.lastName +', '+sectionStudent.student.firstName;
            const studentVariable = changeCase.constantCase(studentName);
            const grade = _.find(response.data, {
              sectionStudentId: sectionStudent.sectionStudentId
            });
            // Descriptive grades live in the parallel letter fields, numeric ones
            // in the original quarter columns. The scheme decides which.
            const scheme = this.getScheme();
            const field = scheme
              ? scheme.fieldFor(parseInt(currentQuarter))
              : getQuarterDbField(parseInt(currentQuarter), 'grades');
            const blank = scheme && scheme.mode === 'descriptive-pace' ? '' : 0;
            this.setState({[studentVariable]: grade != null ? (grade[field] || blank) : blank, areGradesSaved: true})
            return true;
          })
        } else {
          sectionStudents.map((sectionStudent, key )=> {
            const studentName = sectionStudent.student.lastName +', '+sectionStudent.student.firstName;
            const studentVariable = changeCase.constantCase(studentName);

            const emptyScheme = this.getScheme();
            const emptyValue = emptyScheme && emptyScheme.mode === 'descriptive-pace' ? '' : 0;
            this.setState({[studentVariable]: emptyValue, areGradesSaved: false})

            return true;
          })
        }
      });
    });
  }

  // Resolves how this section is graded: how many terms, numeric or letters,
  // which field each term writes to, and the valid range. Falls back to the
  // legacy four-quarter numeric scheme until the section has loaded.
  getScheme() {
    const section = this.state.section && this.state.section[0];
    if (!section) return null;
    // Deliberately no fallback to schoolYearId: an id is not a school year, and
    // letting one through would have it parsed for a four-digit run and
    // silently select a grading mode. No school year means no scheme, and the
    // view shows a loader.
    if (!section.schoolYear) return null;
    return resolveGradingScheme(
      section.schoolYear,
      section.gradeLevel,
      { levelType: section.levelType }
    );
  }

  getSection(sectionId) {
    axios.get(process.env.REACT_APP_URL+'/sections?filter[where][active]=true&filter[include]=schoolYear&filter[where][sectionId]='+sectionId)
    .then(response => {
      this.setState({ section: response.data});
    });
  }

  getSectionSubject = (sectionSubjectId) => {
    axios.get(process.env.REACT_APP_URL+'/sectionSubjects?filter[where][active]=true&filter[include]=subject&filter[include]=details&filter[where][sectionSubjectId]='+sectionSubjectId)
    .then(async(response) => {
      await this.getSectionSubjectDetailsForChecking();
      await this.getSectionSubjectDetailsForReview();
      await this.getSectionSubjectDetailsForApproval();
      await this.getSubjects();
      this.setState({ sectionSubject: response.data});
    });
  }

  getSectionSubjectDetailsForChecking = async() => {
    await axios.get(process.env.REACT_APP_URL+`/sectionSubjectDetails?filter[where][active]=true&filter[include]=sectionSubject&filter[where][status]=Created&filter[where][type]=grade&filter[where][quarter]=${this.props.currentQuarter}`)
    .then(response => {
      this.setState({created: response.data})
    });
  }

  getSectionSubjectDetailsForReview = async() => {
    await axios.get(process.env.REACT_APP_URL+`/sectionSubjectDetails?filter[where][active]=true&filter[include]=sectionSubject&filter[where][status]=Checked&filter[where][type]=grade&filter[where][quarter]=${this.props.currentQuarter}`)
    .then(response => {
      this.setState({checked: response.data})
    });
  }

  getSectionSubjectDetailsForApproval = async() => {
    await axios.get(process.env.REACT_APP_URL+`/sectionSubjectDetails?filter[where][active]=true&filter[include]=sectionSubject&filter[where][status]=Reviewed&filter[where][type]=grade&filter[where][quarter]=${this.props.currentQuarter}`)
    .then(response => {
      this.setState({reviewed: response.data})
    });
  }

  getSubjects = async() => {
    await axios.get(process.env.REACT_APP_URL+'/subjects?filter[where][active]=true')
    .then(response => {
      this.setState({ subjects: response.data });
    });
  }

  getSectionStudents(sectionId) {
    axios.get(process.env.REACT_APP_URL+'/sectionStudents?filter[where][active]=true&filter[include]=student&filter[where][sectionId]='+sectionId)
    .then(response => {
      const sorted = _.sortBy(response.data, function(o){return [o.student.lastName, o.student.firstName]})
      this.setState({ sectionStudents: sorted }, () => {
        this.getGrades(this.state.sectionSubjectId);
      });
    });
  }

  /**
   * Submitting a grade sheet is two requests: the file to storage, then the
   * status up the ladder.
   *
   * They used to be fired side by side, with the upload's failure reaching
   * nothing but console.log. So when storage was unreachable the sheet went
   * nowhere, the row still recorded its filename, the status still advanced to
   * Created, and the teacher was told it had worked. Two sheets were lost that
   * way on 28 September within four minutes of each other - the API was
   * restarting - and nobody found out until the registrar tried to open one
   * and got NoSuchKey from S3.
   *
   * The status now waits for the upload. A failed upload says so, advances
   * nothing, and leaves the sheet for the teacher to submit again.
   */
  async handleUpdateSectionSubjectDetails(data, id) {
    const { currentQuarter } = this.props;
    const sectionSubjectDetail = _.find(this.state.sectionSubject[0].details, {
      quarter: parseInt(currentQuarter),
      type: 'grade'
    });

    const isSubmission = sectionSubjectDetail.status === 'To Do' ||
      sectionSubjectDetail.status === 'Discarded' ||
      sectionSubjectDetail.status === 'Resubmit';

    if (isSubmission) {
      if (!this.state.gradeSheet) {
        alert('Please choose the grade sheet file before submitting.')
        return
      }
      if (this.state.gradeSheet.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
        alert('File extension must be xlsx. Please save your grade sheet in xlsx format.')
        this.setState({open: false})
        return
      }

      let fileData = new FormData();
      fileData.append('filePath', this.state.gradeSheet);
      const uploadUrl = `${process.env.REACT_APP_URL}/containers/${process.env.REACT_APP_CONTAINER}/upload`;

      try {
        await axios.request({
          method:'post',
          url:`${uploadUrl}`,
          data: fileData
        });
      } catch (err) {
        console.log(err);
        alert('The grade sheet could not be uploaded, so nothing was submitted. ' +
          'This is usually the server being briefly unavailable - please try ' +
          'again in a moment. Your grades have NOT been sent.')
        this.setState({open: false})
        return
      }
    }

    const url = process.env.REACT_APP_URL+'/sectionSubjectDetails/'+id;

    try {
      await axios.request({
        method: 'put',
        url: url,
        data: data
      });
      alert('The status of this subject was successfully updated.')
      this.setState({open: false}, this.getSectionSubject(this.state.sectionSubjectId))
    } catch (err) {
      console.log(err);
      // The sheet is in storage but the row did not move. Saying so is the
      // point: silence here is what caused the lost sheets in the first place.
      alert(isSubmission
        ? 'Your grade sheet was uploaded, but the status could not be updated. ' +
          'Please open this subject again and submit once more.'
        : 'The status could not be updated. Please try again.')
      this.setState({open: false})
    }
  }

  handleSort(clickedColumn) {
    const { column, sectionStudents, direction } = this.state
    if (column !== clickedColumn) {
      if(clickedColumn === 'name') {
        this.setState({
          column: clickedColumn,
          sectionStudents: _.sortBy(sectionStudents, function(o){return o.student.lastName}),
          direction: 'ascending',
        })
        return
      } else {
        this.setState({
          column: clickedColumn,
          sectionStudents: _.sortBy(sectionStudents, [clickedColumn]),
          direction: 'ascending',
        })
        return
      }
    }
    this.setState({
      sectionStudents: sectionStudents.reverse(),
      direction: direction === 'ascending' ? 'descending' : 'ascending',
    })
  }

  /**
   * How much of the PACE form is filled in for this subject and term, across
   * the whole section.
   *
   * Fetched at submit time rather than on load: it is a couple of hundred
   * competencies plus every rating for twenty-odd learners, and nothing else on
   * this page needs it. Submission is a per-section act, so the count has to
   * span the section - one learner's tally would say nothing about whether the
   * subject is ready to go up the ladder.
   *
   * Returns null when this is not a PACE subject, which is the signal to skip
   * the confirmation entirely.
   */
  checkPaceProgress = async () => {
    const scheme = this.getScheme();
    const sectionSubject = this.state.sectionSubject[0];
    if (!scheme || !scheme.usesPace || !sectionSubject) return null;

    const term = parseInt(this.props.currentQuarter, 10);
    const url = process.env.REACT_APP_URL;

    const [competencyRes, studentRes] = await Promise.all([
      axios.get(url + '/competencies?filter[where][active]=true' +
        '&filter[where][subjectKey]=' + encodeURIComponent(sectionSubject.subject.subjectCategory) +
        '&filter[where][gradeLevel]=' + encodeURIComponent(this.state.section[0].gradeLevel)),
      axios.get(url + '/sectionStudents?filter[where][active]=true' +
        '&filter[where][sectionId]=' + sectionSubject.sectionId),
    ]);

    const competencies = competencyRes.data;
    const learners = studentRes.data;
    if (!competencies.length || !learners.length) return null;

    const ratingRes = await axios.get(
      url + '/competencyRatings?filter[where][active]=true' +
      '&filter[where][term]=' + term +
      '&filter[where][sectionSubjectId]=' + sectionSubject.sectionSubjectId);

    // Ratings arrive flat for the whole section; bucket them per learner so
    // countFilled sees the same shape the entry grid gives it.
    const byLearner = {};
    ratingRes.data.forEach((r) => {
      if (!byLearner[r.sectionStudentId]) byLearner[r.sectionStudentId] = {};
      byLearner[r.sectionStudentId][ratingKey(r.competencyId, r.macroSkill)] = r.rating;
    });

    const perLearner = countSlots(competencies, term);
    const filled = learners.reduce((sum, learner) =>
      sum + countFilled(competencies, term, byLearner[learner.sectionStudentId] || {}), 0);

    return { filled, total: perLearner * learners.length, learners: learners.length };
  }

  handleChange = (e, { name, value }) => {
    this.setState({[name]: value, dirtyInput: true})
  }

  handleApprovalOpen = () => {
    this.setState({
      open: true
    })
  }

  handleApprovalClose = () => this.setState({
    open: false
  })

  handleSubmit = () => {

    const {sectionStudents, sectionSubject} = this.state;
    const {currentQuarter} = this.props;

    // Validate currentQuarter is available
    if (!currentQuarter) {
      this.setState({error: 'Quarter information not available', success: false});
      return;
    }

    // Validations
    const scheme = this.getScheme();
    const isDescriptive = scheme && scheme.mode === 'descriptive-pace';
    const minGrade = scheme ? scheme.minGrade : 70;
    const maxGrade = scheme ? scheme.maxGrade : 100;

    const invalidStudents = sectionStudents.filter((sectionStudent) => {
      const studentName = sectionStudent.student.lastName +', '+sectionStudent.student.firstName;
      const studentVariable = changeCase.constantCase(studentName);
      const value = this.state[studentVariable];

      if (value === undefined) {
        return true;
      }

      if (isDescriptive) {
        // Blank is allowed: a competency the teacher has not rated yet.
        if (value === '') return false;
        return !scheme.scaleOptions.some((option) => option.value === value);
      }

      // 0 is the long-standing sentinel for a grade on hold or incomplete.
      if (parseInt(value, 10) === 0) {
        return false;
      }

      return parseInt(value, 10) < minGrade || parseInt(value, 10) > maxGrade || value === '';
    });

    if (invalidStudents.length !== 0) {
      const names = invalidStudents
        .map((s) => s.student.lastName + ', ' + s.student.firstName)
        .join('; ');
      const message = isDescriptive
        ? 'Ratings must be one of ' + scheme.scaleOptions.map((o) => o.value).join(', ') +
          '. Check: ' + names
        : 'Grades must be between ' + minGrade + ' and ' + maxGrade +
          '. You can input 0 for grades that are on hold or incomplete. Check: ' + names;
      this.setState({error: message, success: false})
    } else {
      sectionStudents.map((sectionStudent, key )=> {
        const studentName = sectionStudent.student.lastName +', '+sectionStudent.student.firstName;
        const studentVariable = changeCase.constantCase(studentName);

        // Descriptive ratings go to the letter field, numeric grades to the
        // original quarter column.
        const quarterLabel = scheme
          ? scheme.fieldFor(parseInt(currentQuarter))
          : getQuarterDbField(parseInt(currentQuarter), 'grades');
        const sectionSubjectId = sectionSubject[0].sectionSubjectId;
        const sectionStudentId = sectionStudent.sectionStudentId;
        const data = {
          sectionStudentId: sectionStudentId,
          sectionSubjectId: sectionSubjectId,
          [quarterLabel]:  this.state[studentVariable]
        }

        const url = process.env.REACT_APP_URL+'/grades/upsertWithWhere?where={"sectionSubjectId":"'+sectionSubjectId+'","sectionStudentId":"'+sectionStudentId+'"}';
        axios
          .request({
            method: 'post',
            url: url,
            data: data
          })
          .then(response => {
            this.getGrades(sectionSubjectId)
          })
          .catch(err => console.log(err));

        return true;
      })
      //Show next steps for the approval process
      this.setState({success: true, error: false, dirtyInput: false, open: true})
    }
  }

  handleUploadFileChange(gradeSheet) {
    const { sectionSubject, section } = this.state;
    const { currentQuarter } = this.props;

    const sectionSubjectDetail = _.find(this.state.sectionSubject[0].details, {
      quarter: parseInt(currentQuarter),
      type: 'grade'
    });

    let fileName;
    if (sectionSubjectDetail.resubmitCount) {
      fileName = `${changeCase.paramCase(sectionSubject[0].subject.name)}-${changeCase.paramCase(section[0].name)}-grades-${currentQuarter}(${sectionSubjectDetail.resubmitCount}).xlsx`;
    } else {
      fileName = `${changeCase.paramCase(sectionSubject[0].subject.name)}-${changeCase.paramCase(section[0].name)}-grades-${currentQuarter}.xlsx`;
    }

    const newFileName = `2019-2020/${sectionSubject[0].subject.code}/${fileName}`;
    const file = new File([gradeSheet], newFileName, { type: gradeSheet.type });

    this.setState({gradeSheet: file, fileName: fileName});
  }

  handleFileChange(file) {
    const self = this;
    Papa.parse(file, {
      header: true,
      dynamicTyping: true,
      skipEmptyLines: true,
      complete: function(results) {
        self.handleDataChange(results)
    	}
    });
  }

  handleDataChange(results) {
    // this.handleDataSave(results.data);
    this.setState({results: results.data})
    console.log('Parsing complete:', results);
  }

  handleDataSave() {
    const data = this.state.results;
    const { sectionSubject, sectionStudents } = this.state;
    const quarter = this.props.currentQuarter;
    let parsedStudent = {};

    const scheme = this.getScheme();
    const isDescriptive = scheme && scheme.mode === 'descriptive-pace';
    const quarterLabel = scheme
      ? scheme.fieldFor(quarter)
      : getQuarterDbField(quarter, 'grades');

    // fieldFor returns null for a period this school year does not have, and
    // the row below would then be posted as {"null": 85}.
    if (!quarterLabel) {
      this.setState({
        error: 'Nothing was imported. This school year has no period ' + quarter + '.',
        success: false,
      });
      return;
    }

    // Fall back the same way the manual entry path does rather than reaching
    // into a scheme that may not have resolved.
    const minGrade = scheme ? scheme.minGrade : 70;
    const maxGrade = scheme ? scheme.maxGrade : 100;

    const sectionSubjectId = sectionSubject[0].sectionSubjectId;

    // The import used to write straight through with no checking, so a typo in
    // the spreadsheet became a stored grade. Validate the whole file first, and
    // write nothing if any row is bad.
    const rejected = [];
    for (let i = 0; i < data.length; i++) {
      const raw = data[i]['Grades'];
      const label = data[i]['Student Number'] || ('row ' + (i + 2));

      if (raw === undefined || raw === null || raw === '') {
        rejected.push(label + ': no grade');
        continue;
      }

      if (isDescriptive) {
        const letter = String(raw).trim().toUpperCase();
        if (!scheme.scaleOptions.some((option) => option.value === letter)) {
          rejected.push(label + ': "' + raw + '" is not a valid rating');
        }
      } else {
        const value = parseInt(raw, 10);
        if (isNaN(value)) {
          rejected.push(label + ': "' + raw + '" is not a number');
        } else if (value !== 0 && (value < minGrade || value > maxGrade)) {
          rejected.push(label + ': ' + value + ' is outside ' +
            minGrade + '-' + maxGrade);
        }
      }
    }

    if (rejected.length !== 0) {
      this.setState({
        error: 'Nothing was imported. Fix these rows and upload again — ' +
          rejected.slice(0, 10).join('; ') +
          (rejected.length > 10 ? ' (and ' + (rejected.length - 10) + ' more)' : ''),
        success: false,
      });
      return;
    }

    for (let i = 0; i < data.length; i++) {

      // const firstName = data[i]['First Name'];
      // const lastName = data[i]['Last Name'];
      const studentNumber = data[i]['Student Number'];
      const grade = data[i]['Grades'];

      const student = _.find(sectionStudents, function(o) {
        return o.student.studentNumber === studentNumber
      });
      console.log(student)
      if (student != null) {
        parsedStudent = {
          sectionSubjectId: sectionSubject[0].sectionSubjectId,
          sectionStudentId: student.sectionStudentId,
          [quarterLabel]: isDescriptive ? String(grade).trim().toUpperCase() : grade
        }
      } else {
        alert('Error. Please contact your administrator for assistance.');
        return
      }

      const sectionStudentId = student.sectionStudentId;

      const url = process.env.REACT_APP_URL+'/grades/upsertWithWhere?where={"sectionSubjectId":"'+sectionSubjectId+'","sectionStudentId":"'+sectionStudentId+'"}';
      axios
        .request({
          method: 'post',
          url: url,
          data: parsedStudent
        })
        .then(response => {
          if (i === data.length-1) {
            this.setState({success: true}, () => this.getGrades(sectionSubjectId));
          }
        })
        .catch(error => {
          console.log(error)
          if (error.response) {
            alert(`${error.response.data.error.message}`);
          } else if (error.request) {
            alert(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            alert('Error. Please contact your administrator for assistance.');
          }
        });
    }
    alert('Grades successfully added!')
  }

  componentDidMount() {
    this.props.authFn.getToken()
    this.props.onContentMount({title:'Grades'});

    const sectionId = this.props.match.params.sectionId;
    const sectionSubjectId = this.props.match.params.sectionSubjectId;
    const params = new URLSearchParams(this.props.location.search);
    const quarter = params.get('quarter');
    
    // Update Redux quarter state if quarter is provided in URL
    if (quarter && isValidQuarter(parseInt(quarter))) {
      this.props.quarterActions.setCurrentQuarter(parseInt(quarter));
    }
    
    this.setState({sectionSubjectId: sectionSubjectId}, () => {
      this.getSectionStudents(sectionId);
      this.getSectionSubject(sectionSubjectId);
      this.getSection(sectionId);
    })

  }

  componentDidUpdate(prevProps) {
    const sectionId = this.props.match.params.sectionId;
    const sectionSubjectId = this.props.match.params.sectionSubjectId;
    const prevSectionId = prevProps.match.params.sectionId;
    const prevSectionSubjectId = prevProps.match.params.sectionSubjectId;
    const params = new URLSearchParams(this.props.location.search);
    const quarter = params.get('quarter');

    // Only update if route params actually changed
    const hasChanged = sectionId !== prevSectionId ||
                      sectionSubjectId !== prevSectionSubjectId ||
                      this.props.currentQuarter !== prevProps.currentQuarter;

    if (!hasChanged) {
      return; // Prevent duplicate API calls
    }

    // Update Redux quarter state if quarter is provided in URL
    if (quarter && isValidQuarter(parseInt(quarter))) {
      this.props.quarterActions.setCurrentQuarter(parseInt(quarter));
    }

    // Clear any existing timeout
    if (this.updateTimeout) {
      clearTimeout(this.updateTimeout);
    }

    // Add 1 second delay before making API calls
    this.updateTimeout = setTimeout(() => {
      this.setState({sectionSubjectId: sectionSubjectId}, () => {
        this.getSectionStudents(sectionId);
        this.getSectionSubject(sectionSubjectId);
        this.getSection(sectionId);
      });
    }, 1000);
  }

  render() {
    return (
      <GradesPV
        auth={this.props.auth}
        username={this.props.username}
        userType={this.props.userType}
        userId={this.props.userId}
        column={this.state.column}
        direction={this.state.direction}
        section={this.state.section}
        sectionSubject={this.state.sectionSubject}
        sectionStudents={this.state.sectionStudents}
        error={this.state.error}
        success={this.state.success}
        quarter={this.props.currentQuarter}
        scheme={this.getScheme()}
        onCheckPaceProgress={this.checkPaceProgress}
        fileName={this.state.fileName}
        areGradesSaved={this.state.areGradesSaved}
        dirtyInput={this.state.dirtyInput}
        open={this.state.open}
        created={this.state.created}
        checked={this.state.checked}
        reviewed={this.state.reviewed}
        subjects={this.state.subjects}
        {...this.state}
        handleApprovalOpen={this.handleApprovalOpen}
        handleApprovalClose={this.handleApprovalClose}
        handleUpdateSectionSubjectDetails={this.handleUpdateSectionSubjectDetails}
        handleDataSave={this.handleDataSave}
        handleSort={this.handleSort}
        handleChange={this.handleChange}
        handleSubmit={this.handleSubmit}
        handleFileChange={this.handleFileChange}
        handleUploadFileChange={this.handleUploadFileChange}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authFn: AuthA(dispatch),
    quarterActions: QuarterA(dispatch)
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.AuthR.auth,
    username: state.AuthR.username,
    userType: state.AuthR.userType,
    userId: state.AuthR.userId,
    currentQuarter: state.QuarterR.currentQuarter,
    schoolYearId: state.QuarterR.schoolYearId
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(GradesPC);
